import { render, staticRenderFns } from "./CertificationChangeNotesAccordion.vue?vue&type=template&id=330e59af&scoped=true"
import script from "./CertificationChangeNotesAccordion.vue?vue&type=script&lang=js"
export * from "./CertificationChangeNotesAccordion.vue?vue&type=script&lang=js"
import style0 from "./CertificationChangeNotesAccordion.vue?vue&type=style&index=0&id=330e59af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330e59af",
  null
  
)

export default component.exports